import * as React from 'react';
import { ReactNode } from 'react';
import { ExternalLink } from '../../components/ExternalLink';
import { Row } from './layout/Row';
import { SubRow } from './layout/Subrow';

export interface UrlRender {
  url: string;
  type: string;
}

interface Props {
  urls: UrlRender[];
  title: string;
}

export const UrlsRow = ({urls, title}: Props): ReactNode => {
  if (!urls || !urls.length) return null;
  return (
    <Row title={title}>
      {urls.map((url: UrlRender, index: number): ReactNode =>
        <SubRow key={index}>
          {url.type}
          <ExternalLink href={url.url}>{url.url}</ExternalLink>
        </SubRow>,
      )}
    </Row>
  );
};
